import './App.css';
import { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Article from './pages/Article';
import Login from './pages/Login';
import ProblemSolving from './pages/ProblemSolving';
import DataTable from './pages/NCPro/DataTable';
import Report from './pages/NCPro/Report';
import ChangePassword from './pages/ChangePassword';
import Users from './pages/Users';
import ForgotPassword from './pages/ForgotPassword';
import NCProPages from './pages/NCPro/NCProPages';
import NCProHome from './pages/NCProHome'
import NotFound from './pages/404';
import MobileWarning from './Components/Common/MobileWarning';

function AppRoutes() {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 800);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const mobileAllowedRoutes = ['/', '/article', '/8d-problem-solving'];
  const isRouteAllowedOnMobile = mobileAllowedRoutes.includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/article' element={<Article />} />
        <Route path='/8d-problem-solving' element={<ProblemSolving />} />
        <Route path='/homearticle' element={<NCProHome />} />
        <Route path='/login' element={<Login />} />
        <Route path='/users' element={<Users />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path="/ncpro/:page" element={<NCProPages />} />
        <Route path="/ncpro/:page/:id" element={<NCProPages />} />
        <Route path='/report/8d' element={<Report />} />
        <Route path='/report/datatable' element={<DataTable />} />
        <Route path='/change-password' element={<ChangePassword />} />
        <Route path='*' element={<NotFound />} />
      </Routes>

      {isMobile && !isRouteAllowedOnMobile && <MobileWarning />}
    </>
  );
}

export default AppRoutes;
